import React from 'react'
import styled from 'styled-components'
import { navigate } from 'gatsby'

import { TimelineLite } from "gsap/all"
import Transition from 'react-transition-group/Transition'

import BaseLayout from '../BaseLayout'
import Footer from '../BaseLayout/footer'

const HeroContainer = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 80vh;
  justify-content: flex-start;
  margin: 0 auto;

  @media( min-width: ${props => props.theme.sm} ) {
    justify-content: space-around;
    flex-direction: row;
    max-width: 900px;
  }
`
const NavChevronLeft = styled.svg`
  cursor: pointer;
  height: 15px;
  position: fixed;
  top: 53vh;
  left: 2vw;
  transform: rotate(0deg) scaleX(-1);
  width: 15px;
  z-index: 10;

  @media (min-width: ${props => props.theme.xs} ) {
    height: 30px;
    width: 30px;
  }
`
const NavChevronRight = styled.svg`
  cursor: pointer;
  height: 15px;
  position: fixed;
  top: 53vh;
  right: 2vw;
  transform: rotate(180deg) scaleX(-1);
  width: 15px;
  z-index: 10;

  @media (min-width: ${props => props.theme.xs} ) {
    height: 30px;
    width: 30px;
  }
`

export default class Milestone extends React.Component {

  // State engine
  constructor(props){
    super(props);
    
    this.state = {
      intervalId: 0, // For scrollTop
      show: true // for Transition RTG, set to true because we want to trigger on component mount
    };

    // You have to set each element you want to null so gsap can wait for react to do it's magic
    this.introcontainer = null
    this.herobackground = null
		this.herotext = null
    this.heroimage = null
    this.bodycontainer = null
    
    // Binds toggleShowState to this - helps trigger the Transition component
    this.toggleShowState = this.toggleShowState.bind(this);
    this.animateLoad = this.animateLoad.bind(this);
    this.goToThePrevPage = this.goToThePrevPage.bind(this);
    this.goToTheNextPage = this.goToTheNextPage.bind(this);
  }
  
  // scrollTo top setup
  scrollStep() {
    // Checks for vertical offset, if it's zero we just aren't going to do anything
    // Other we scroll the offset distance
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - 50);
  }
  
  scrollToTop() {
    // We set the scroll distance interval to whatever the scrollStep() function said we should
    // Then we reset react state accordingly - all this gets triggered on exit sequence from page
    let intervalId = setInterval(this.scrollStep.bind(this), 10);
    this.setState({ intervalId: intervalId });
  }

  // Turns the show state false, triggers exit
  toggleShowState() {
    this.setState({ 
      show: false 
    });
  }

  animateLoad() {
    const animateLoad = new TimelineLite()
    
    animateLoad.set(
      this.introcontainer, { 
        display: 'block' 
      }).from(
      this.herobackground, 0.7, { 
        transform: 'translateX(100vw)', 
        autoAlpha: 1,
        ease: 'Cubic.easeInOut'
      }, 0.1).from(
      this.heroimage, 0.7, { 
        transform: 'translateX(80vw)', 
        autoAlpha: 1,
        ease: 'Cubic.easeInOut'
      }, 0.2).from(
      this.herotext, 0.7, { 
        transform: 'translateX(80vw)', 
        autoAlpha: 1,
        ease: 'Cubic.easeInOut'
      }, 0.2).from(
      this.bodycontainer, 0.8, {
        transform: 'translateY(80px)', 
        autoAlpha: 0,
      }, 0.3).play()
  }

  goToThePrevPage() {
    // Grab nextpage, put it into a variable before gsap mangles it
    const prevPageURL = this.props.previouspage
    const goToThePrevPage = new TimelineLite()

    goToThePrevPage.set(
      this.introcontainer, { 
        autoAlpha: 1
      }).to(
      this.heroimage, 1, { 
        transform: 'translateX(-350vw)', 
        autoAlpha: 1,
        ease: 'Cubic.easeInOut'
      }, 0.3).to(
      this.herotext, 1, { 
        transform: 'translateX(-350vw)', 
        autoAlpha: 1,
        ease: 'Cubic.easeInOut'
      }, 0.3).to(
      this.herobackground, 0.7, { 
        css: {
          transform: 'translateX(-100vw)', 
          autoAlpha: 1,
          ease: 'Cubic.easeInOut'
        }
      }, 0.6).to(
      this.bodycontainer, 0.8, {
        transform: 'translateY(50px)', 
        autoAlpha: 0,
      }, 0.1).eventCallback("onComplete", function() {
        navigate(prevPageURL)
      }).play()
  }

  goToTheNextPage() {
    // heroTimelineOut sets up animations as the elements go out
    // gsap has a .reverse method but our 'out' animation is actually different (exit left)
    // we scroll to top of the page, then sequence the animations out
    
    // Grab nextpage, put it into a variable before gsap mangles it
    const nextPageURL = this.props.nextpage
    const goToTheNextPage = new TimelineLite()

    goToTheNextPage.set(
      this.introcontainer, { 
        autoAlpha: 1
      }).to(
      this.heroimage, 1, { 
        transform: 'translateX(-350vw)', 
        autoAlpha: 1,
        ease: 'Cubic.easeInOut'
      }, 0.3).to(
      this.herotext, 1, { 
        transform: 'translateX(-350vw)', 
        autoAlpha: 1,
        ease: 'Cubic.easeInOut'
      }, 0.3).to(
      this.herobackground, 0.7, { 
        transform: 'translateX(-100vw)', 
        autoAlpha: 1,
        ease: 'Cubic.easeInOut'
      }, 0.6).to(
      this.bodycontainer, 0.8, {
        transform: 'translateY(50px)', 
        autoAlpha: 0,
      }, 0.4).eventCallback("onComplete", function() {
        navigate(nextPageURL)
      }).play()
  }
 
  render() {    
    return (  
      <BaseLayout>
        <Transition
          timeout={ 100 }
          appear={ true }
          in={ this.state.show }
          mountOnEnter={ true }
          onEntering={ 
            () => { this.animateLoad() } 
          }>
          <div>
            <NavChevronLeft 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 16 16" 
              fill="none" 
              stroke="currentcolor" 
              strokeWidth="2"
              id="previous-page"
              onClick={ 
                () => { 
                  // Fire scrollToTop and then heroTimelineOut
                  // Check for window so we don't upset SSR build
                  // Then we make sure we're not at the top of the page
                  if (typeof window !== `undefined`) {
                    if (window.pageYOffset === 0) {
                      this.goToThePrevPage()
                    } else {
                      this.scrollToTop()
                      this.goToThePrevPage()
                    }
                  }
                } 
              }>
              <path d="M5 0.7071067811865475 L12.292893218813452 8 L5 15.292893218813452"></path>
            </NavChevronLeft>
            <NavChevronRight 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 16 16" 
              fill="none" 
              stroke="currentcolor" 
              strokeWidth="2"
              id="next-page"
              onClick={ 
                () => { 
                  // Same logic as above
                  if (typeof window !== `undefined`) {
                    if (window.pageYOffset === 0) {
                      this.goToTheNextPage()
                    } else {
                      this.scrollToTop()
                      this.goToTheNextPage()
                    }
                  }
                } 
              }>
              <path d="M5 0.7071067811865475 L12.292893218813452 8 L5 15.292893218813452"></path>
            </NavChevronRight>

            {/**
              * Super weird 'ref' prop is how gsap holds back react until the component mounts
              * I'll be honest code reader - I don't really understand this piece
              * Best to read some of this: https://greensock.com/react
              */}
            <header className="introcontainer" ref={ header => this.introcontainer = header }>
              <section 
                className={`herobackground ${ this.props.bgcolor }`} 
                ref={ section => this.herobackground = section }>
                <HeroContainer>
                  <div className="herotext" ref={ div => this.herotext = div }>
                    <span className="herobutton">{ this.props.button }</span>
                    <h1 className="herotitle">{ this.props.title }</h1>
                  </div>
                  <img
                    alt={ this.props.imgalt } 
                    className="heroimage" 
                    ref={ img => this.heroimage = img } 
                    src={ this.props.imgsrc } />
                </HeroContainer>
              </section>
            </header>

            <section className="bodycontainer" ref={ section => this.bodycontainer = section }>
              { this.props.body }
            </section> 
            <Footer />
          </div>
        </Transition>
      </BaseLayout>
    )
  }
}
